'use client';

import React, { useEffect, useState } from 'react';

import styles from './productShippingDebug.module.scss';

interface ProductShippingDebugProps {
  label: string;
  data: Record<string, unknown>;
}

export function shouldShowProductShippingDebug(): boolean {
  if (process.env.NEXT_PUBLIC_DEBUG_PRODUCT_SHIPPING === 'true') {
    return true;
  }

  return process.env.NODE_ENV === 'development';
}

export default function ProductShippingDebug({ label, data }: ProductShippingDebugProps) {
  const [visible, setVisible] = useState(shouldShowProductShippingDebug());

  useEffect(() => {
    if (shouldShowProductShippingDebug()) {
      setVisible(true);
      return;
    }

    const params = new URLSearchParams(window.location.search);
    setVisible(params.get('debugProduct') === '1');
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <details className={styles.debug} open>
      <summary className={styles.summary}>{label}</summary>
      <pre className={styles.pre}>{JSON.stringify(data, null, 2)}</pre>
    </details>
  );
}
